import styled, { css, keyframes } from 'styled-components'
import { ArrowRight, ChevronRight } from '@styled-icons/fa-solid'
import variables from '../../styles/variables'

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const Container = styled.div`
  margin: 0;
  max-width: 400px;
  width: 100%;
  opacity: 1;
`

export const CompactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: transparent;
  border-radius: 12px;
  padding: 1.5rem;
  width: 100%;
`

export const CodeSection = styled.div`
  width: 100%;
`

export const CodeLabel = styled.div`
  font-family: ${variables.fonts.header};
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`

export const CodeBlock = styled.div`
  background: rgba(14, 15, 27, 0.9);
  border-radius: 8px;
  padding: 1.25rem;
  overflow-x: auto;
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  
  /* Style plain pre tags for our dark theme */
  pre {
    margin: 0;
    padding: 0;
    background: transparent !important;
    overflow: visible;
    color: ${variables.colors.pearlBrush.lighter};
    font-size: 14px;
    line-height: 1.5;
    font-family: ${variables.fonts.mono};
    white-space: pre-wrap;
    
    @media ${variables.media.sm} {
      font-size: 14px;
    }
  }
  
  code {
    color: ${variables.colors.pearlBrush.lighter} !important;
    font-size: 14px;
    line-height: 1.5;
    font-family: ${variables.fonts.mono};
    
    @media ${variables.media.sm} {
      font-size: 14px;
    }
  }
  
  /* JSON syntax highlighting colors */
  .token.property {
    color: ${variables.colors.bondiBlue.light};
  }
  
  .token.string {
    color: ${variables.colors.turquoiseAccent};
  }
  
  .token.number {
    color: ${variables.colors.sunsetOrange.light};
  }
  
  .token.punctuation {
    color: ${variables.colors.pearlBrush.light};
  }
  
  .token.operator {
    color: ${variables.colors.carnationPink.light};
  }
`

export const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  
  @media ${variables.media.md} {
    padding: 2rem 0;
  }
`

export const Arrow = styled(ArrowRight)`
  width: 24px;
  height: 24px;
  color: ${variables.colors.silverTree.medium};
  transform: rotate(90deg);
  
  @media ${variables.media.md} {
    transform: rotate(0);
  }
`

export const CTAWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`

export const CTAButton = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: ${variables.fonts.body};
  font-size: 1.125rem;
  font-weight: 600;
  color: ${variables.colors.white};
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  background: ${variables.colors.turquoiseAccent};
  transition: all 0.2s ease;
  cursor: pointer;
  
  &:hover {
    background: ${variables.colors.coreViolet};
    color: ${variables.colors.white};
    transform: translateX(2px);
  }
`

export const CTAArrow = styled(ChevronRight)`
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
  
  ${CTAButton}:hover & {
    transform: translateX(4px);
  }
`

export const ResponseSection = styled.div`
  opacity: 1;
`

export const CompactResponseBlock = styled(CodeBlock)`
  font-size: 12px;
  padding: 1rem;
  background: rgba(14, 15, 27, 0.9);
  
  pre {
    font-size: 12px !important;
  }
  
  code {
    font-size: 12px !important;
  }
`